module.exports = __webpack_public_path__ + "media/images/features/refund/eyecatch-mv-7ac86c02429a9560f3b2e2fcc3d644c1.png";